import { useEffect } from "react";
import { useMutation } from "urql";

import { Header } from "@/components/layout/header";
import { Main } from "@/components/layout/main";
import { useNewOrganizationStore } from "@/features/NewOrganization/components/NewOrganizationStore";
import { NewOrganization } from "@/features/NewOrganization/routes/NewOrganization";
import { graphql } from "@/gql";
import { FrequentlyAskedQuestions } from "@/features/NewOrganization/components/FrequentlyAskedQuestions";

const DeleteSubscriptionIntentQuery = graphql(`
  mutation DeleteSubscriptionIntentQuery($subscriptionId: String!) {
    deleteOrganizationSubscriptionIntent(
      input: { subscriptionId: $subscriptionId }
    ) {
      status
    }
  }
`);

const RouteComponent = () => {
  const [, deleteIntent] = useMutation(DeleteSubscriptionIntentQuery);

  useEffect(() => {
    return () => {
      const reset = useNewOrganizationStore.getState().reset;
      const intentId = useNewOrganizationStore.getState().intent?.id;
      if (intentId) {
        deleteIntent({ subscriptionId: intentId });
      }

      reset();
    };
  }, [deleteIntent]);

  return (
    <>
      <Header fixed />

      <Main>
        <div className="p-4 space-y-4">
          <h1>Create a new Organization</h1>
          <NewOrganization />
          <div className="py-16 sm:py-24 max-w-4xl mx-auto">
            <FrequentlyAskedQuestions />
          </div>
        </div>
      </Main>
    </>
  );
};

export const Route = createFileRoute({
  component: RouteComponent,
});
